<template>
  <span
    class="inline-block px-2 py-1 font-medium rounded-full"
    :class="[
      textClass,
      { ' bg-gray-100 text-gray-800': type === '' || type === ' GRAY'},
      { ' bg-blue-100 text-blue-800': type === 'BLUE'},
      { ' bg-yellow-100 text-yellow-800': type === 'YELLOW'},
      { ' bg-green-100 text-green-800': type === 'GREEN'},
      { ' bg-red-100 text-red-800': type === 'RED'},
    ]"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'MBadge',
  props: {
    type: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: 'text-sm',
    },
  },
};
</script>

<style>

</style>
